import React from "react";
import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import Image from "@amzn/meridian/image";
import { HeadSection, FooterDesktop } from "../../../shared";
import "../eligibleProduct.css";
import plugfonesAllertSrc from "../../../shared/images/desktop/plugfones-alert.jpg";
import PriceSection from "../../../shared/components/priceSection";
import FeaturesComparison from "../../../shared/components/featuresComparison";
import PurchaseNowButton from "../../../shared/components/purchaseNowButton";
import {
  prices,
  PLUGFONES_ALLERT_INDEX,
} from "../../../shared/constants/paths";
import { PLUGFONES_ALLERT_TITLE } from "../../../shared/constants/messages";
import { useBundle } from "@amzn/react-arb-tools";
import { PRODUCTPAGE_MESSAGE_BUNDLE_NAME, LOCALE_VALUES } from "src/constants";
import { t } from "src/helpers";
import useCountryCodeContext from "src/components/shared/context/useCountryCodeContext";
import useLocaleContext from "src/components/shared/context/useLocaleContext";
import {
  getPlugfonesAllertUrls,
  isCountryCodeCanada,
} from "src/components/shared/utils/utils";

const SortCenterProducts = () => {
  const [bundle] = useBundle(PRODUCTPAGE_MESSAGE_BUNDLE_NAME);
  const { countryCodeValue: countryCode } = useCountryCodeContext();
  const { language } = useLocaleContext();
  const isCanada = isCountryCodeCanada(countryCode);
  const imageWidths = ["fill"];
  const priceSectionWidths = ["40%", "fill"];

  return (
    <Column heights={["7em", "fill", "4em", "5em"]} spacing="400">
      <HeadSection widths type="d100" alignmentHorizontal="center">
        {t(bundle, "compare_eligible_products")}
      </HeadSection>
      <Row widths={["grid-2", "grid-8"]}>
        <Column></Column>
        <Column>
          <Row widths={imageWidths}>
            <Image
              src={plugfonesAllertSrc}
              size="contain"
              viewportHeight={250}
            />
          </Row>
          <Row widths={priceSectionWidths}>
            <Column></Column>
            <Column>
              <Text type="h400" fontFamily="bookerly">
                {PLUGFONES_ALLERT_TITLE}
              </Text>
              <PriceSection
                price={prices[PLUGFONES_ALLERT_INDEX]}
              ></PriceSection>
              <PurchaseNowButton
                url={getPlugfonesAllertUrls(language)}
              ></PurchaseNowButton>
            </Column>
          </Row>
          <Row></Row>
          <FeaturesComparison
            widths={priceSectionWidths}
            isCanada={isCanada}
            isSortCenter={true}
          ></FeaturesComparison>
        </Column>
      </Row>
      <Row></Row>
      <FooterDesktop></FooterDesktop>
    </Column>
  );
};

export default SortCenterProducts;
